module.exports = {
  "country": "PL",
  "artist": "Anna Maria Jopek",
  "song": "Aje jestem",
  "year": "1997",
  "place": "11",
  "spotify": "7uzp5lbbq4fn2p0zjd1Dhi"
};